import { render, staticRenderFns } from "./NewMoneyTable.vue?vue&type=template&id=893cf534&scoped=true"
import script from "./NewMoneyTable.vue?vue&type=script&lang=js"
export * from "./NewMoneyTable.vue?vue&type=script&lang=js"
import style0 from "./NewMoneyTable.vue?vue&type=style&index=0&id=893cf534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893cf534",
  null
  
)

export default component.exports